const { camelCase, isFunction } = require('lodash');

class ToggleButtonController {
    constructor($element) {
        this.$element = $element;
    }

    $onInit() {
        this.inputId = this.getId();

        if (isFunction(this.onChange)) {
            this.change = () => this.onChange({ value: this.value });
        }

        // If there's no model, use JS onchange instead of ng-change
        if (this.model === undefined && this.change) {
            this.$element.on('change', 'input', this.change);
        }
    }

    getId() {
        return this.inputId || `toggleButton-${camelCase(`${this.name} ${this.label}`).replace(/\W/g, '')}`;
    }
}

ToggleButtonController.$inject = ['$element'];

const ToggleButtonComponentDefinition = {
    controller: ToggleButtonController,
    template: require('./toggle-button.component.html').trim(),
    bindings: {
        buttonClass: '@?',
        inputId: '@?',
        isSelected: '<?', // Will be ignored if model is defined
        label: '@',
        model: '=?',
        name: '@',
        onChange: '&?', // Will be called from either JS onchange or ng-change depending on model presence
        value: '<',
        eventRecorder: '@?',
        eventCategory: '@?',
        eventLabel: '@?',
        eventName: '@?',
    },
};

module.exports = {
    ToggleButtonController,
    ToggleButtonComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/togglebutton/toggle-button.component.js